import { createFileRoute, redirect } from '@tanstack/react-router'
import { Settings } from '@/features/settings'

export const Route = createFileRoute('/_authenticated/profile')({
  staticData: { sidebar: 'profile' },
  beforeLoad: ({ location }) => {
    if (location.pathname === '/profile' || location.pathname === '/profile/') {
      throw redirect({
        to: '/profile/settings',
        replace: true,
      })
    }
  },
  component: Settings,
})
